import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Text from '../Text';

const TypeChangeApproveDialog = ({ visible, onApprove, onCancel }) => {
    const [password, setPassword] = React.useState("");
    const [error, setError] = React.useState("");

    const handleContinue = () => {
        if (password === "1234") {
            onApprove();
        } else {
            setError("Wrong password");
        }
    }

    return (
        <Dialog
            open={visible}
            onClose={onCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Type was changed!
            </DialogTitle>

            <DialogContent style={{ paddingTop: 12 }}>
                <Text
                    label="user.password"
                    value={password}
                    onChange={setPassword}
                    type="password"
                    error={!!error}
                    helperText={error}
                    errorMessages={['this field is required']} />
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button
                    onClick={handleContinue}
                    disabled={password.length < 3}
                    autoFocus>
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default TypeChangeApproveDialog;